// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyApdUFMcb-c_oK_fgN6p89FQG-yLEZgzuw",
  authDomain: "vaccine-tracking-app.firebaseapp.com",
  projectId: "vaccine-tracking-app",
  storageBucket: "vaccine-tracking-app.firebasestorage.app",
  messagingSenderId: "435375340214",
  appId: "1:435375340214:web:9476cec7d64695b6b10417",
  measurementId: "G-VPNS1VCNHM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export default app;